import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const HighlightedContainer = styled(Box)`
	border-radius: 4px;
	${({ theme }) => `
		background-color: ${theme.palette.backgroundColors.lighterGrey};
	`}
	padding: 0.5rem;
`

export const FieldContainer = styled(Box)`
	flex: 1;
	min-width: 20%;
	max-width: 25%;
`

export const FieldRow = styled(Box)`
	display: flex;
	flex-wrap: wrap;
	gap: 0.75rem;
`
